import { addMonths, addWeeks } from 'date-fns';
import { times } from 'ramda';

export const generateWeeklySchedule = (seed, maxCount) =>
  times(x => addWeeks(seed, x), maxCount);

export const generateMonthlySchedule = (seed, maxCount) =>
  times(x => addMonths(seed, x), maxCount);
